/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  flowerCareGrid: {
    minHeight: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: theme.palette.thankyoucards.typography
  },
  innerFlowerGrid: {
    width: '100%',
    paddingBottom: '1rem',
  },
  card: {
    maxWidth: '350px',
    margin: "auto",
  },
  flowerGrid: {
    paddingBottom: '2rem',
    '& .mbp-account-MuiPaper-root': {
      borderRadius: 0,
    },
  },
  media: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  pageTitle: {
    fontFamily: theme.palette.thankyoucards.titleTypography,
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '36px',
    textAlign: 'center',
    letterSpacing: '0.01em',
    marginTop: '2rem',
    marginBottom: '4px'
  },
  pageSubtitle: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '16px',
    textAlign: 'center',
    letterSpacing: '0.01em',
    marginTop: '0px',
    marginBottom: '2rem'
  },
  cardTitle: {
    fontFamily: theme.palette.thankyoucards.titleTypography,
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '30px',
    letterSpacing: '0.01em',
    marginTop: '0px',
    marginBottom: '10px'
  },
  cardDescription: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.common.black,
    margin: '0px',
  },
  contentWrapper: {
    paddingBottom: '40px',
    '& strong': {
      fontWeight: '700',
    },
  },
  contentHeader: {
    fontFamily: theme.palette.thankyoucards.titleTypography,
    textAlign: 'center',
    paddingBottom: '12px',
    fontSize: '20px',
    margin: '0px',
  }
}));

const RecipientFlowerCareTab = ({ reference, id }) => {
  const classes = useStyles();

  const flowerCareData = [
    {
      title: 'Give Them a Warm Welcome:',
      description: 'Trim the Stems with sharp scissors or a knife and gently snip about an inch off the stems at a 45-degree angle. This haircut helps them drink the water they need!',
      imgSrc: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt90e22836d4d08e41/664b905b76a5b5531a31aed5/flowercare_step_1.webp',
    },
    {
      title: 'Prepare the Water:',
      description: 'Add lukewarm water to your vase and then add the flower food by following the directions on the packet included with your bouquet.',
      imgSrc: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltcd73a7507841ebff/664b905b68f4301a8b347f71/flowercare_step_2.webp',
    },
    {
      title: 'Find the Perfect Spot:',
      description: 'Keep the flowers in a cool place away from direct sunlight, open windows and vents. This will help the flowers stay fresh longer.',
      imgSrc: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltd2ed90f05ca07cbf/664b905b628a4f2cd66292e6/flowercare_step_3.webp',
    }
  ]

  return (
    <div id={`section-${id}`} ref={reference} className={classes.flowerCareGrid} >
      <h1 className={classes.pageTitle}>
        Flower Care Guide
      </h1>
      <h2 className={classes.pageSubtitle}>How to Keep Your Flowers Happy</h2>
      <div className={classes.innerFlowerGrid}>
        {flowerCareData?.map((flowerCare) => {
          return (
            <div key={flowerCare.title} className={classes.flowerGrid} item>
              <div elevation={0} className={classes.card}>
                <img
                  className={classes.media}
                  src={flowerCare.imgSrc}
                  alt={flowerCare.title}
                />
                <div className={classes.cardContent} align="start">
                  <h2 className={classes.cardTitle}>
                    {flowerCare.title}
                  </h2>
                  <p className={classes.cardDescription}>
                    {flowerCare.description}
                  </p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
      <div className={`${classes.contentWrapper} ${classes.card}`}>
        <h2 className={classes.contentHeader}>Extra Care Tips</h2>
        <p><strong>Remove Wilting Flowers:</strong> Regularly check and remove any wilting flowers or leaves to prevent them from affecting the rest of the arrangement.</p>
        <p><strong>Stay Away from Fruit:</strong> Avoid placing your flowers near ripening fruit, which emit ethylene gas that can cause your flowers to age prematurely.</p>
        <p><strong>Change the Water Regularly:</strong> Refresh the water every two days. This keeps the water from getting cloudy and reduces the risk of bacterial growth. Each time you change the water, remember to re-trim the stems and clean the vase.</p>
      </div>
    </div>
  );
};

export default RecipientFlowerCareTab;